import {Component, OnInit} from '@angular/core';

import {AppComponent} from '../app.component'

import {HttpService} from '../services/HttpService';
import {NotificationService} from '../services/NotificationService';
import {EditSuggestionComponent} from '../edit-suggestion/edit-suggestion.component';
import {ViewUserComponent} from '../view-user/view-user.component';

import {MatDialog} from '@angular/material';

import swal from 'sweetalert2';

import {FacebookService, UIParams, UIResponse} from 'ngx-facebook';
import {environment} from '../../environments/environment';


@Component({
    selector: 'app-suggestions',
    templateUrl: './suggestions.component.html',
    styleUrls: ['./suggestions.component.scss'],
    providers: [HttpService, NotificationService]
})
export class SuggestionsComponent implements OnInit {

    public isBrandParent = false;

    public imagesToShow;

    public allBrands;

    public sortValue: string = '';

    public showImagesModalBool = false;

    public parentBrandData;

    public User_Details: any;
    public allSuggestions;

    public showType: string = 'suggestions';


    public brandToShowSuggestionsFor;

    public showCommentModal = false;

    public brandOptions = [];
    public filterOptions = {
        brand: 0
    }

    public reverse: boolean = false;

    public commentData = {
        comment_text: ''
    }

    public showCommentEditModal = false;

    public suggestionToComment;

    public commentToEdit;

    public apiUrl = environment.apiUrl;

    public currentPage = 1;

    constructor(
        public http: HttpService,
        public notification: NotificationService,
        public app: AppComponent,
        public dialog: MatDialog,
        private fb: FacebookService
    ) {


    }

    ngOnInit() {

        this.getSuggestionsData()
    }

    getSuggestionsData(page = 1, reported = 0) {
        this.User_Details = JSON.parse(localStorage.getItem('Admin_User_Details'));
        console.log(this.User_Details)
        if (this.User_Details.role.id == 1) {
            this.app.loading = true;
            this.http.makeRequestPost([
                `admin/user/suggestion/getallsuggestions?page=${page}`,
                {
                    token: this.User_Details.token,
                    reported
                }
            ])
            .subscribe(
                (response) => {
                    this.app.loading = false;
                    if (response.data) {
                        this.allSuggestions = response.data.suggestions;


                        this.brandOptions = response.data.brands;
                        this.brandOptions.unshift({name: 'All', id: 0});

                        document.body.scrollTo({top: 0, behavior: 'smooth'});
                        document.documentElement.scrollTo({top: 0, behavior: 'smooth'});
                    }
                    if (response.error) {
                        this.notification.showNotification('Could not get all suggestions', 'Error', 'error');
                    }
                },
                (error) => {
                    this.app.loading = false;
                    this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                }
            )
        } else {

            this.app.loading = true;
            this.http.makeRequestPost([
                `brand/admin/suggestion/get?page=${page}`,
                {
                    token: this.User_Details.token,
                    id: this.User_Details.brandadmins[0].id,
                    reported
                }
            ])
            .subscribe(
                (response) => {
                    this.app.loading = false;
                    if (response.data) {
                        this.allSuggestions = response.data.suggestions;
                        console.log(this.allSuggestions);
                        this.brandOptions = response.data.brands;
                        this.brandOptions.unshift({name: 'All', id: 0});

                        document.body.scrollTo({top: 0, behavior: 'smooth'});
                        document.documentElement.scrollTo({top: 0, behavior: 'smooth'});
                    }
                    if (response.error) {
                        this.notification.showNotification('Could not get all suggestions', 'Error', 'error');
                    }
                },
                (error) => {
                    this.app.loading = false;
                    this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                }
            )
        }
    }

    markNotAbusive(suggestion) {
        swal({
            title: 'Confirmation',
            text: 'Are you sure you want to mark this suggestion as not abusive?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            buttonsStyling: false,
            imageUrl: 'assets/img/Popup_Squirrel.png',
            imageWidth: 100,
            showCloseButton: true,
            animation: false,
            confirmButtonClass: 'btn btn-orange btn-block btn-full input-block-level',
            cancelButtonClass: 'btn btn-orange-outline btn-block btn-full input-block-level',
            reverseButtons: true
        }).then((data) => {
            console.log(data);
            if (data.value) {
                this.app.loading = true;
                this.http.makeRequestPost(['admin/user/suggestion/markNotAbusive',
                    {
                        token: this.User_Details.token,
                        id: suggestion.id
                    }])
                .subscribe(
                    (resp) => {
                        this.app.loading = false;
                        if (resp.data) {
                            if (resp.data.reported == 0 && resp.data.abusive == 0) {
                                for (var i = 0; i < this.allSuggestions.length; i++) {
                                    if (this.allSuggestions[i].id == suggestion.id) {
                                        this.allSuggestions[i] = resp.data;
                                    }
                                }
                                this.notification.showNotification('The suggestion has been marked as not abusive', 'Success', 'success');
                            } else {
                                this.notification.showNotification('Could not mark the suggestion as not abusive', 'Error', 'error');
                            }
                        }
                        if (resp.error) {
                            this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                        }
                    },
                    (error) => {
                        this.app.loading = false;
                        this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                    }
                )
            }
        });
    }

    markAbusive(suggestion) {
        swal({
            title: 'Confirmation',
            text: 'Are you sure you want to mark this suggestion as abusive?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            buttonsStyling: false,
            imageUrl: 'assets/img/Popup_Squirrel.png',
            imageWidth: 100,
            showCloseButton: true,
            animation: false,
            confirmButtonClass: 'btn btn-orange btn-block btn-full input-block-level',
            cancelButtonClass: 'btn btn-orange-outline btn-block btn-full input-block-level',
            reverseButtons: true
        }).then((data) => {
            console.log(data);
            if (data.value) {
                this.app.loading = true;
                this.http.makeRequestPost(['admin/user/suggestion/markAbusive',
                    {
                        token: this.User_Details.token,
                        id: suggestion.id
                    }])
                .subscribe(
                    (resp) => {
                        this.app.loading = false;
                        if (resp.data) {
                            if (resp.data.reported == 1 && resp.data.abusive == 1) {
                                for (var i = 0; i < this.allSuggestions.length; i++) {
                                    if (this.allSuggestions[i].id == suggestion.id) {
                                        this.allSuggestions[i] = resp.data;
                                    }
                                }
                                this.notification.showNotification('The suggestion has been marked as abusive', 'Success', 'success');
                            } else {
                                this.notification.showNotification('Could not mark the suggestion as abusive', 'Error', 'error');
                            }
                        }
                        if (resp.error) {
                            this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                        }
                    },
                    (error) => {
                        this.app.loading = false;
                        this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                    }
                )
            }
        });
    }

    showUserDetails(user) {
        console.log(user);

        let dialogRef = this.dialog.open(ViewUserComponent, {
            width: '100vw',
            height: '100vh',
            data: {userDetails: user}
        });

        dialogRef.afterClosed().subscribe((result) => {


        });

    }


    reportSuggestion(suggestion) {
        swal({
            title: 'Confirmation',
            text: 'Are you sure you want to report this suggestion as abusive?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            buttonsStyling: false,
            imageUrl: 'assets/img/Popup_Squirrel.png',
            imageWidth: 100,
            showCloseButton: true,
            animation: false,
            confirmButtonClass: 'btn btn-orange btn-block btn-full input-block-level',
            cancelButtonClass: 'btn btn-orange-outline btn-block btn-full input-block-level',
            reverseButtons: true
        }).then((data) => {
            console.log(data);
            if (data.value) {
                this.app.loading = true;
                this.http.makeRequestPost(['brand/admin/suggestion/report',
                    {
                        token: this.User_Details.token,
                        id: suggestion.id
                    }])
                .subscribe(
                    (resp) => {
                        this.app.loading = false;
                        if (resp.data) {
                            if (resp.data.reported == 1) {
                                for (var i = 0; i < this.allSuggestions.length; i++) {
                                    if (this.allSuggestions[i].id == suggestion.id) {
                                        this.allSuggestions[i] = resp.data;
                                    }
                                }

                                this.notification.showNotification('The suggestion has been reported', 'Success', 'success');
                            } else {
                                this.notification.showNotification('Could not report the suggestion', 'Error', 'error');
                            }
                        }
                        if (resp.error) {
                            this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                        }
                    },
                    (error) => {
                        this.app.loading = false;
                        this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                    }
                )
            }
        });
    }

    rewardSuggestion(suggestion) {
        console.log('rewardSuggestion called');
        swal({
            title: 'Confirmation',
            text: 'Are you sure you want to reward the user for this suggestion?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            buttonsStyling: false,
            imageUrl: 'assets/img/awesome_award.svg',
            imageWidth: 100,
            showCloseButton: true,
            animation: false,
            confirmButtonClass: 'btn btn-orange btn-block btn-full input-block-level',
            cancelButtonClass: 'btn btn-orange-outline btn-block btn-full input-block-level',
            reverseButtons: true
        }).then((data) => {
            console.log(data);
            if (data.value) {
                this.app.loading = true;
                this.http.makeRequestPost(['brand/admin/suggestion/reward',
                    {
                        token: this.User_Details.token,
                        id: suggestion.id
                    }])
                .subscribe(
                    (resp) => {
                        this.app.loading = false;
                        if (resp.data) {
                            if (resp.data.rewarded == 1) {
                                suggestion.rewarded = 1;
                                for (var i = 0; i < this.allSuggestions.length; i++) {
                                    if (this.allSuggestions[i].id == suggestion.id) {
                                        this.allSuggestions[i] = resp.data;
                                    }
                                }
                                swal({
                                    title: 'You\'ve awarded  ' + resp.data.user[0].name + '.',
                                    text: 'Please contact ' + resp.data.user[0].name + ' directly on ' + resp.data.user[0].email + ' to reward them. ',
                                    type: 'warning',
                                    showCancelButton: false,
                                    confirmButtonText: 'Ok',
                                    buttonsStyling: false,
                                    imageUrl: 'assets/img/Popup_Squirrel.png',
                                    imageWidth: 100,
                                    showCloseButton: false,
                                    animation: false,
                                    confirmButtonClass: 'btn btn-orange btn-block btn-full input-block-level',
                                    cancelButtonClass: 'btn btn-orange-outline btn-block btn-full input-block-level',
                                    reverseButtons: false
                                }).then((data) => {
                                    if (data.value) {
                                        swal({
                                            title: 'Share?',
                                            text: 'Would you like to share this on your brand Facebook page?',
                                            type: 'warning',
                                            showCancelButton: true,
                                            confirmButtonText: 'Yes',
                                            buttonsStyling: false,
                                            imageUrl: 'assets/img/Popup_Squirrel.png',
                                            imageWidth: 100,
                                            showCloseButton: true,
                                            animation: false,
                                            confirmButtonClass: 'btn btn-orange btn-block btn-full input-block-level',
                                            cancelButtonClass: 'btn btn-orange-outline btn-block btn-full input-block-level',
                                            reverseButtons: true
                                        }).then((data) => {
                                            if (data.value) {
                                                if (suggestion.photos.length > 0) {
                                                    const options: UIParams = {
                                                        method: 'share',
                                                        quote: suggestion.user[0].name + ' ' + suggestion.user[0].surname + ' ' + 'has been rewarded for their suggestion: ' + suggestion.description + ' to the brand: ' + suggestion.brand[0].name + ' @[{10216349012700562}:{xander hattingh}]',
                                                        href: environment.apiUrl + 'get_image/' + suggestion.photos[0].image_path,
                                                    };
                                                    this.fb.ui(options)
                                                    .then(
                                                        (res: UIResponse) => {
                                                            console.log('Got the users profile', res);
                                                        })
                                                    .catch((error) => {
                                                        this.notification.showNotification('Unable to share', 'Error', 'error');
                                                    });
                                                } else {
                                                    const options: UIParams = {
                                                        method: 'share',
                                                        quote: suggestion.user[0].name + ' ' + suggestion.user[0].surname + ' ' + 'has been rewarded for their suggestion: ' + suggestion.description + ' to the brand: ' + suggestion.brand[0].name + ' @[{10216349012700562}:{xander hattingh}]',
                                                        href: environment.apiUrl + 'get_image/suggestion.jpg',
                                                    };
                                                    this.fb.ui(options)
                                                    .then(
                                                        (res: UIResponse) => {
                                                            console.log('Got the users profile', res);
                                                        })
                                                    .catch((error) => {
                                                        this.notification.showNotification('Unable to share', 'Error', 'error');
                                                    });
                                                }
                                            }
                                        }).catch(swal.noop);

                                        this.notification.showNotification('The user has been rewarded', 'Success', 'success');
                                    }
                                }).catch(swal.noop);

                                this.notification.showNotification('The user has been rewarded', 'Success', 'success');
                            } else {
                                this.notification.showNotification('Could not reward the user for the suggestion', 'Error', 'error');
                            }
                        }
                        if (resp.error) {
                            this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                        }
                    },
                    (error) => {
                        this.app.loading = false;
                        this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                    }
                )
            }
        })

    }

    editSuggestion(suggestion) {
        let dialogRef = this.dialog.open(EditSuggestionComponent, {
            width: '100vw',
            data: {suggestionDetails: suggestion, allBrands: this.brandOptions}
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                if (result.changedSuggestion) {
                    for (var i = 0; i < this.allSuggestions.length; i++) {
                        if (this.allSuggestions[i].id == suggestion.id) {
                            this.allSuggestions[i] = result.changedSuggestion;
                        }
                    }
                }
            }

        });
    }

    deleteSuggestion(suggestion) {
        swal({
            title: 'Confirmation',
            text: 'Are you sure you want to delete this suggestion?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            buttonsStyling: false,
            imageUrl: 'assets/img/Popup_Squirrel.png',
            imageWidth: 100,
            showCloseButton: true,
            animation: false,
            confirmButtonClass: 'btn btn-orange btn-block btn-full input-block-level',
            cancelButtonClass: 'btn btn-orange-outline btn-block btn-full input-block-level',
            reverseButtons: true
        }).then((data) => {
            if (data.value) {
                console.log('delete the suggestion');
                console.log(suggestion);
                this.app.loading = true;
                this.http.makeRequestPost(['admin/user/suggestion/delete', {token: this.User_Details.token, id: suggestion.id}])
                .subscribe(
                    (response) => {
                        this.app.loading = false;
                        if (response.data) {
                            if (response.data.length != 0) {
                                for (var i = 0; i < this.allSuggestions.length; i++) {
                                    if (this.allSuggestions[i].id == suggestion.id) {
                                        this.allSuggestions.splice(i, 1);
                                    }
                                }
                            } else {
                                this.notification.showNotification('Could not delete the suggestion', 'Error', 'error');
                            }
                        }
                        if (response.error) {
                            this.notification.showNotification('Could not delete the suggestion', 'Error', 'error');
                        }
                    },
                    (error) => {
                        this.app.loading = false;
                        this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                    }
                )
            }

        })
    }

    setShowType(value: string) {
        console.log(value);
        this.showType = value;
    }

    onLinkClick(evt) {
        console.log(evt.tab.textLabel.toLowerCase());
        this.showType = evt.tab.textLabel.toLowerCase();
        if (evt.tab.textLabel.toLowerCase() == 'reported') {
            this.getSuggestionsData(0, 1);

        } else {
            this.getSuggestionsData(0, 0);
        }
        // .textLabel.toLowerCase()
        // this.showType = value;
    }


    showImagesModal(photos) {
        this.showImagesModalBool = true;
        this.imagesToShow = photos;
    }

    toggleShowOptions(suggestion) {
        console.log(suggestion)
        if (suggestion.showOptions == true) {
            suggestion.showOptions = false;
        } else {
            for (var i = 0; i < this.allSuggestions.data.length; i++) {
                this.allSuggestions.data[i].showOptions = false;
            }

            suggestion.showOptions = true;
        }
    }

    toggleBrandParentOptions(brand) {
        if (brand.showParentOptions == true) {
            brand.showParentOptions = false;
        } else {
            for (var i = 0; i < this.allBrands.length; i++) {
                this.allBrands[i].showParentOptions = false;
            }

            brand.showParentOptions = true;
        }
    }

    showBrandSuggestions(brand) {
        this.app.loading = true;
        this.http.makeRequestPost([
            'brand/admin/suggestion/get',
            {
                token: this.User_Details.token,
                id: brand.id
            }
        ])
        .subscribe(
            (response) => {
                this.app.loading = false;
                if (response.data) {
                    this.allSuggestions = response.data.suggestions;
                    this.brandToShowSuggestionsFor = brand;
                    brand.showOptions = false;
                }
                if (response.error) {
                    this.notification.showNotification('Could not get all suggestions', 'Error', 'error');
                }
            },
            (error) => {
                this.app.loading = false;
                this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
            }
        )
    }

    showChildBrands() {
        delete (this.brandToShowSuggestionsFor);
    }


    setTypeToShow(evt) {
        console.log(evt);
    }

    dismissall() {
        for (var i = 0; i < this.allSuggestions.length; i++) {
            this.allSuggestions[i].showOptions = false;
        }
    }

    toggleCommentModal(suggestion) {
        console.log(suggestion)
        this.showCommentModal = true;
        this.suggestionToComment = suggestion

    }

    createSuggestionComment() {
        // admin/user/suggestion/comment
        this.app.loading = true;
        this.http.makeRequestPost(['admin/user/suggestion/comment', {
            token: this.User_Details.token,
            suggestion_id: this.suggestionToComment.id,
            brand_id: this.User_Details.Brands[0].id,
            comment_text: this.commentData.comment_text
        }])
        .subscribe(
            (resp) => {
                this.app.loading = false;
                if (resp.data) {
                    this.showCommentModal = false;
                    this.commentData = {
                        comment_text: ''
                    };
                    delete (this.suggestionToComment)
                    for (var i = 0; i < this.allSuggestions.length; i++) {
                        if (this.allSuggestions[i].id == resp.data.suggestion_id) {
                            this.allSuggestions[i].comments.push(resp.data);
                        }
                    }
                } else {
                    this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                }
            },
            (error) => {
                this.app.loading = false;
                this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
            }
        )
    }

    dismissCommentAll() {
        console.log('calling the dismiss all');
        for (var i = 0; i < this.allSuggestions.data.length; i++) {
            for (var n = 0; n < this.allSuggestions.data[i].comments.length; n++) {
                this.allSuggestions.data[i].comments[n].showOptions = false;
            }
        }
    }

    editComment(suggestion: any, comment) {
        this.suggestionToComment = suggestion;
        this.commentToEdit = comment;
        this.commentToEdit.hide = true;
        suggestion.new_comment_text = this.commentToEdit.comment;
        // this.commentData = {
        //     comment_text: comment.comment_text
        // }
        // this.showCommentEditModal = true;
    }

    deleteComment(suggestion: any, comment) {
        swal({
            title: 'Confirmation',
            text: 'Are you sure you want to delete this comment?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            buttonsStyling: false,
            imageUrl: 'assets/img/Popup_Squirrel.png',
            imageWidth: 100,
            showCloseButton: true,
            animation: false,
            confirmButtonClass: 'btn btn-orange btn-block btn-full input-block-level',
            cancelButtonClass: 'btn btn-orange-outline btn-block btn-full input-block-level',
            reverseButtons: true
        }).then((data) => {
            console.log(data);
            if (data.value) {
                this.app.loading = true;
                this.http.makeRequestPost(['admin/user/suggestion/comment/delete', {
                    token: this.User_Details.token,
                    comment_id: comment.id,
                }])
                .subscribe(
                    (resp) => {
                        this.app.loading = false;
                        if (resp.data) {
                            for (var i = 0; i < this.allSuggestions.data.length; i++) {
                                for (var n = 0; n < this.allSuggestions.data[i].comments.length; n++) {
                                    if (this.allSuggestions.data[i].comments[n].id == resp.data.id) {
                                        this.allSuggestions.data[i].comments.splice(n, 1);
                                    }
                                }
                            }
                            this.showCommentEditModal = false;
                            this.commentData = {
                                comment_text: ''
                            }
                            delete this.commentToEdit;
                            delete this.suggestionToComment;
                        } else {
                            this.app.loading = false;
                            this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                        }
                    },
                    (error) => {
                        this.app.loading = false;
                        this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                    }
                )
            }
        });
    }

    saveSuggestionComment() {
        this.app.loading = true;
        this.http.makeRequestPost(['admin/user/suggestion/comment/edit', {
            token: this.User_Details.token,
            comment_id: this.commentToEdit.id,
            comment_text: this.commentData.comment_text
        }])
        .subscribe(
            (resp) => {
                this.app.loading = false;
                if (resp.data) {
                    for (var i = 0; i < this.allSuggestions.length; i++) {
                        for (var n = 0; n < this.allSuggestions[i].comments.length; n++) {
                            if (this.allSuggestions[i].comments[n].id == resp.data.id) {
                                this.allSuggestions[i].comments[n] = resp.data;
                            }
                        }
                    }
                    this.showCommentEditModal = false;
                    this.commentData = {
                        comment_text: ''
                    }
                    delete this.commentToEdit;
                    delete this.suggestionToComment;
                } else {
                    this.app.loading = false;
                    this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                }
            },
            (error) => {
                this.app.loading = false;
                this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
            }
        )
    }

    loadPage(evt) {
        this.currentPage = evt;
        this.getSuggestionsData(evt, 0)
    }

    protected sendComment(suggestion) {
        if (this.commentToEdit) {
            this.sendEditComment(suggestion);
            return;
        }
        this.app.loading = true;
        this.http.makeRequestPost(['admin/user/suggestion/comment', {
            ...suggestion, brand_user_id: this.User_Details.id,
            token: this.User_Details.token,
        }])
        .subscribe({
            next: (resp: any) => {
                console.log(resp);
                if (resp.data) {
                    suggestion.new_comment_text = '';
                    suggestion.comments.push(resp.data);
                } else {
                }
            },
            error: (error) => {
                console.log(error);
            },
            complete: () => {
                this.app.loading = false;
            }
        });
    }

    protected sendEditComment(suggestion) {
        console.log(suggestion);
        this.app.loading = true;
        this.http.makeRequestPost(['admin/user/suggestion/edit/comment', {
            ...suggestion, brand_user_id: this.User_Details.id,
            token: this.User_Details.token,
            comment: this.commentToEdit
        }])
        .subscribe({
            next: (resp: any) => {

                console.log(resp);
                if (resp.data) {
                    for (var i = 0; i < suggestion.comments.length; i++) {
                        if (this.commentToEdit.id == suggestion.comments[i].id) {
                            suggestion.comments[i].comment = suggestion.new_comment_text;
                        }
                    }
                    suggestion.new_comment_text = ''
                    this.commentToEdit.hide = false;
                    delete (this.commentToEdit);
                } else {
                }
            },
            error: (error) => {
                console.log(error);
            },
            complete: () => {
                this.app.loading = false;
            }
        });
    }


    autoGrow(el: HTMLTextAreaElement) {
        el.style.height = 'auto';                          // shrink first so it can re-measure
    }

    protected cancelCommentEdit(suggestion) {
        for (var i = 0; i < suggestion.comments.length; i++) {
            suggestion.comments[i].hide = false;
            suggestion.new_comment_text = '';
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/suggestions/suggestions.component.ts